interface Translator {
  (key: any): string;
  has(key: any): boolean;
}

export default function getLocalizedLanguageLabel(
  languageCode: string | undefined,
  translate: Translator
): string | null {
  const normalizedCode = languageCode?.trim();

  if (!normalizedCode || normalizedCode.toLowerCase() === 'xx') return null;

  const translationKey = `iso_639_1.${normalizedCode.toLowerCase()}`;

  return translate.has(translationKey)
    ? translate(translationKey)
    : normalizedCode;
}
